exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grouped-form .v-text-field {\n  border: 1px solid #e4e5e7;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 130%;\n}\n.pass-field {\n  position: relative;\n  height: 50px;\n}\n.pass-field img {\n  position: absolute;\n  top: 30%;\n  right: 12px;\n  cursor: pointer;\n}\n.service-agreement {\n  font-size: 14px;\n  line-height: 130%;\n  color: #1b1e22;\n  margin-top: 24px;\n}\n.already-login span,\n.service-agreement span {\n  color: #0781f2;\n  cursor: pointer;\n}\n", ""]);

// exports
